import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GlobalContextProvider } from './context';
import TagManager from 'react-gtm-module';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import { UserProvider } from './context/userContext';
import ToastContainer from './components/ToastContainer';
import { CartProvider } from './context/cartProvider';
import "react-multi-carousel/lib/styles.css";

// if(process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY && process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY.length){
//     const tagManagerArgs = {
//       gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY
//     };
//     TagManager.initialize(tagManagerArgs);
// }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<GlobalContextProvider> <UserProvider><CartProvider><Router><ToastContainer /><App/></Router></CartProvider></UserProvider></GlobalContextProvider>);
